import React from "react";

const COLORS = ["#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#F0BE39", "#FF8F47", "#3EB567", "#FF7AAC"];

const buildDots = () => {
  const dots = [];
  const cols = 10;
  const rows = 8;
  const colSpace = 100 / (cols + 1);
  const rowSpace = 100 / (rows + 1);
  for (let r = 0; r < rows; r++) {
    for (let c = 0; c < cols; c++) {
      const i = r * cols + c;
      const color = COLORS[(i * 7 + r * 3) % COLORS.length];
      dots.push({
        cx: (c + 1) * colSpace,
        cy: (r + 1) * rowSpace,
        r: 0.55 + (i % 4) * 0.08,
        color,
        delay: -((i * 0.37) % 12).toFixed(2),
        dur: 10 + (i % 5),
      });
    }
  }
  return dots;
};

const DOTS = buildDots();

export const DotsBackground = ({ bgColor = "#3E8DFF" }) => (
  <div className="absolute w-full h-full overflow-hidden">
    <svg
      preserveAspectRatio="xMidYMid slice"
      className="w-full h-full"
      viewBox="0 0 100 100"
      style={{ backgroundColor: bgColor }}
    >
      <defs>
        <style>{`
          @keyframes dotPulse {
            0%,100% { transform: scale(0.85); opacity: 0.55; }
            50%     { transform: scale(1.15); opacity: 0.9;  }
          }
          .pulse-dot {
            animation: dotPulse ease-in-out infinite;
            transform-origin: center;
            transform-box: fill-box;
          }
        `}</style>
      </defs>
      {DOTS.map((d, i) => (
        <circle
          key={i}
          className="pulse-dot"
          cx={d.cx}
          cy={d.cy}
          r={d.r}
          fill={d.color}
          style={{ animationDelay: `${d.delay}s`, animationDuration: `${d.dur}s` }}
        />
      ))}
    </svg>
  </div>
);
